import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import CloseVirtualCardContent from 'src/app/CloseVirtualCardContent/CloseVirtualCardContent'
import { selectVirtualCardIdFromRoute } from 'src/app/CloseVirtualCardContent/redux/closeVirtualCardContent.selectors'
import { useFlyoutDispatch } from 'src/hooks'
import { connectedReplace } from 'src/navigation/Lnk'
import { closeVirtualCardUrl } from 'src/navigation/urls'
import {
  useQueryVirtualCardDetail,
  useQueryVirtualCardPermissions,
} from 'src/queries/virtualCards.queries'

const CloseBillPayCard: React.FC = (): React.ReactElement => {
  const dispatch = useFlyoutDispatch()
  const virtualCardId = useSelector(selectVirtualCardIdFromRoute)
  const { data: virtualCard } = useQueryVirtualCardDetail({ virtualCardId })

  useQueryVirtualCardPermissions({ virtualCardId })

  useEffect(() => {
    if (virtualCard === undefined) return

    if (!virtualCard.isBillPay) {
      // user is trying to access a regular card, redirect to the virtual card url
      dispatch(connectedReplace(closeVirtualCardUrl(virtualCardId)))
    }
  }, [virtualCard])

  return (
    <CloseVirtualCardContent
      virtualCardId={virtualCardId}
      virtualCard={virtualCard}
    />
  )
}

export default CloseBillPayCard
